import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styled from 'styled-components'
import Button from '../../components/Button'
import Card from '../../components/Card'
import Input from '../../components/Input'
import request from '../../utils/request'

const LinkBox = styled.div`
  display: flex;
  justify-content: space-between;
`

@observer
export default class Step1 extends Component {
  @observable error = false
  @observable loading = false
  
  @observable
  fields = {
    email: '',
  }

  @action
  setField = event => {
    this.error = false
    this.fields[event.target.name] = event.target.value
  }

  @action
  setLoading = () => {
    this.loading = true
    this.error = false
  }

  @action
  setError = () => {
    this.loading = false
    this.error = true
  }

  submit = async event => {
    event.preventDefault()
    this.setLoading()
    const res = await request('/api/auth/step1', this.fields)

    if (res.success) {
      window.location = '/api/saml/sso';
    } else {
      this.setError()
    }
  }

  render() {
    return (
      <Card>
        {this.error && <Card.ErrorMessage />}
        <form onSubmit={this.submit}>
          <Card.Pad>
            <Input
              disabled={this.loading}
              label="titles.email"
              name="email"
              value={this.fields.email}
              onChange={this.setField}
            />
            <LinkBox>
              <div>&nbsp;</div>
              {/* <Link
                str="titles.signUp"
                to="/sign-up"
              /> */}
              {/* <Link
                str="titles.accountRecovery"
                to="/account-recovery"
              /> */}
            </LinkBox>
          </Card.Pad>
          <Card.Divider />
          <Card.Pad>
            <Button
              str="titles.signIn"
              color="blue"
              type="submit"
            />
          </Card.Pad>
        </form>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Login/Step1.js